import valeriePic from "@/public/images/artists/valerie.png";
import { Artist } from "@/types/types";

export const valerie = {
  id: "3",
  name: "Valerie",
  image: valeriePic,
  description: `Rooted in soul and jazz, Valerie carries a rich, velvety quality that exudes both power and vulnerability. Her vocals, filled with depth and authenticity, breathe life into her lyrics, telling stories of heartache and passion.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fvalerie-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Pop", "Dance", "RnB", "Airy"],
      secondary: ["Singer"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 55,
        high: 69,
      },
    },
  },
} as const satisfies Artist;
